import { render } from "./SelectBox.vue?vue&type=template&id=3ae9befb"
import script from "./SelectBox.vue?vue&type=script&lang=js"
export * from "./SelectBox.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__